import { render, staticRenderFns } from "./RegisterPre.vue?vue&type=template&id=4722d3b8&"
import script from "./RegisterPre.vue?vue&type=script&lang=js&"
export * from "./RegisterPre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports